import { gtcAddToCart } from "gtcUtils";


class GiftWrapping extends HTMLElement {
  constructor() {
    super();
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
  }

  connectedCallback() {
    this.dom = {
      checkbox: this.querySelector("input[type='checkbox']")
    };

    this.settings = {
      giftWrapTitle: this.getAttribute("data-gift-wrap-title"),
      giftWrapId: this.getAttribute("data-gift-wrap-id"),
      lineKey: this.getAttribute("data-line-item-key"),
      lineItemTitle: this.getAttribute("data-line-item-title"),
      lineItemVariantId: this.getAttribute("data-line-item-variant-id"),
      lineItemQuantity: this.getAttribute("data-line-item-quantity"),
      giftWrapTotalQuantity: this.getAttribute(
        "data-gift-wrap-total-quantity"
      ),
    };

    this.addEventListeners();
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }

  addEventListeners() {
    this.dom.checkbox.addEventListener("change", this.handleCheckboxChange);
  }

  removeEventListeners() {
    this.dom.checkbox.removeEventListener("change", this.handleCheckboxChange);
  }

  async cartChange(body) {
    try {
      const response = await fetch(`${ Shopify.routes.root }cart/change.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error("Failed to update cart");
      }
      return await response.json();

    } catch (error) {
      this.errorHandler(error);
    }
  }

  async addGiftWrapping() {
    try {
      // Remove the current line item
      await this.cartChange({
        id: this.settings.lineKey,
        quantity: parseInt(this.settings.lineItemQuantity, 10) - 1,
      });

      await gtcAddToCart({
        items: [{
          'id': this.settings.lineItemVariantId,
          'quantity': 1,
          properties: {
            _gift_wrap_title: this.settings.giftWrapTitle,
            _gift_wrapping: this.settings.lineKey,
            _timestamp: new Date().getTime(),
          },
        },
        {
          id: this.settings.giftWrapId,
          quantity: 1,
          properties: {
            _gift_wrapping: this.settings.lineKey,
          }
        }]
      });
    } catch (error) {
      this.errorHandler(error);
    }

  }

  async removeGiftWrapping() {
    // Remove the gift wrapping variant

    const cart = await fetch(`${ Shopify.routes.root }cart.js`)
      .then(response => response.json())
      .catch(error => {
        this.errorHandler(error);
      });
    const giftWrapItem = cart.items.find((item) => {
      return item.properties._timestamp === this.settings.lineKey;
    }
    );

    await this.cartChange({
      id: this.settings.giftWrapId,
      quantity: parseInt(this.settings.giftWrapTotalQuantity, 10) - 1,
    });

    // Remove the gift wrapping line item
    await this.cartChange({
      id: this.settings.lineKey,
      quantity: 0,
    });

    // Add the original line item
    await gtcAddToCart({
      items: [{
        id: this.settings.lineItemVariantId,
        quantity: 1,
      }]
    });

  }

  async handleCheckboxChange(event) {
    const isChecked = event.target.checked;
    this.dom.checkbox.disabled = true;

    document.documentElement.dispatchEvent(new CustomEvent('gift-wrapping:loading', {
      bubbles: true,
    }));

    if (isChecked) {
      await this.addGiftWrapping();
    } else {
      await this.removeGiftWrapping();
    }

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
      })
    );

    document.documentElement.dispatchEvent(new CustomEvent('gift-wrapping:loaded', { bubbles: true }));
  }

  errorHandler(error) {
    this.dom.checkbox.disabled = false;
    this.classList.remove("loading");
    console.error("👨🏻‍💻 -> GiftWrapping -> errorHandler -> error:", error);
  }

}
if (!window.customElements.get("gift-wrapping")) {
  window.customElements.define("gift-wrapping", GiftWrapping);
}

class GiftWrappingLoader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {

    document.addEventListener("gift-wrapping:loading", () => {
      this.classList.add("loading");
    });

    document.addEventListener("gift-wrapping:loaded", () => {
      this.classList.remove("loading");
    });

  }
}

if (!window.customElements.get("gift-wrpping-loader")) {
  window.customElements.define("gift-wrpping-loader", GiftWrappingLoader);
}